<template>
  <form-item
    v-if="isForm"
    v-bind="$attrs"
    :name="name"
    :prop="propName"
    :hasLabel="hasLabel"
    :label="label"
    :hasDesc="hasDesc"
    :descContent="desc"
    :rules="rules"
    >
    <el-select
      v-if="component === 'select'"
      v-model="val"
      @input="onInput"
      @change="onChange"
      class="form-item"
      :placeholder="placeholder"
      :disabled="disabled"
      :multiple="enableMultiple"
      :multipleLimit="multipleLimit"
      >
      <el-option
        v-for="item in opts"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled"
        >
      </el-option>
    </el-select>
    <el-radio-group
      v-else-if="component === 'radio-button'"
      v-model="val"
      @input="onInput"
      @change="onChange"
      class="form-item"
      :disabled="disabled"
      >
      <el-radio
        v-for="item in opts"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
        border
        >
        {{ item.label }}
      </el-radio>
    </el-radio-group>
    <el-switch
      v-else-if="component === 'switch'"
      v-model="val"
      :active-value="1"
      :inactive-value="0"
      @input="onInput"
      @change="onChange"
      :active-text="swActiveText"
      :inactive-text="swInactiveText"
      :disabled="disabled"
    >
    </el-switch>
  </form-item>
  <el-table-column
    v-else
    ref="tblCol"
    :label="label"
    :align="align"
    :prop="propName"
    :column-key="dataName"
    :filters="filters"
    :filter-method="filterMethod"
    :filtered-value="filteredValue"
    :filter-multiple="opts.length > 2"
    :width="width"
    >
    <template slot-scope="scope">
      <el-popover
        v-if="name === 'status' && (type === 'refund' || type === 'invoice')"
        :disabled="!!!scope.row.rtn_msg"
        trigger="hover"
      >
        <div
          v-text="getRetMsg(scope.row)"
        ></div>
        <span
          slot="reference"
          v-text="getOptLabel(scope.row[dataName])"></span>
      </el-popover>
      <div
        v-else-if="(name === 'status' || name === 'ordersStatus')
          && (type === 'orders')"
        >
        <el-tooltip
          v-if="scope.row.gift_id != null"
          class="item"
          effect="dark"
          placement="top-end"
          >
          <div slot="content">
            <div class="align-center allow-click-copy"
              @click="doCopy(scope.row.gift_id)"
            >
              {{ scope.row.gift_id }}
            </div>
            <div class="align-center">
              ⮃
            </div>
            <div class="align-center allow-click-copy"
              @click="doCopy(scope.row.unhide_gift_id)"
            >
              {{ scope.row.unhide_gift_id }}
            </div>
          </div>
          <svg-icon icon-class="baseline-gift-black-24px"></svg-icon>
        </el-tooltip>
        <el-tooltip
          v-if="scope.row['incapable'] === 1"
          class="item"
          effect="dark"
          placement="top-end"
          :content="$t('api.orders.refundComp.isIncapable')"
          >
          <i
            class="el-icon-warning"
            ></i>
        </el-tooltip>
        <span
          v-text="getOptLabel(scope.row[dataName])"
          >
        </span>
      </div>
      <el-tooltip
        v-else-if="getToolTipText(scope.row) !== ''"
        class="item"
        effect="dark"
        placement="top-end"
        :content="getToolTipText(scope.row)"
        >
        <span v-text="getOptLabel(scope.row[dataName])">
        </span>
      </el-tooltip>
      <div v-else>
        <el-button
          v-if="displayStyle === 'button'"
          size="mini"
          v-text="getOptLabel(scope.row[dataName])"
        >
        </el-button>
        <el-tag
          v-else-if="displayStyle === 'tag'"
          :type="tagType(scope.row)"
          v-text="getOptLabel(scope.row[dataName])"
        >
        </el-tag>
        <span
          v-else
          v-text="getOptLabel(scope.row[dataName])">
        </span>
        <el-tooltip
          v-if="showTipIcon(scope.row)"
          class="item"
          effect="dark"
          placement="top-end"
          :content="iconTip"
          >
          <i v-if="iconClass != ''" :class="iconClass" :style="{color: iconColor}"></i>
        </el-tooltip>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { updateFilter } from '@/utils/filter'
import { getMap, getTransText } from '@/utils/i18n'

export default {
  name: 'std-opt',
  props: {
    value: null,
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    data: {
      type: String
    },
    prop: {
      type: String
    },
    type: {
      type: String,
      default: 'enabled'
    },
    component: {
      type: String,
      default: 'select'
    },
    width: {
      type: String,
      default: '100'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasLabel: {
      type: Boolean,
      default: true
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    hasFilter: {
      type: Boolean,
      default: true
    },
    hasReadme: {
      type: Boolean,
      default: false
    },
    getToolTipText: {
      type: Function,
      default: () => {
        return ''
      }
    },
    iconClass: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: 'black'
    },
    iconTip: {
      type: String,
      default: ''
    },
    showTipIcon: {
      type: Function,
      default: () => {
        return false
      }
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    filterMethod: {
      type: Function,
      default: undefined
    },
    inputOpts: {
      type: Array,
      default: () => []
    },
    hiddenValue: {
      type: Array,
      default: () => []
    },
    isShowLabel: {
      type: Boolean,
      default: true
    },
    isForm: {
      type: Boolean,
      default: true
    },
    enableMultiple: {
      type: Boolean,
      default: false
    },
    multipleLimit: {
      type: Number,
      default: 0
    },
    labelText: {
      type: String,
      default: null
    },
    placeholderText: {
      type: String,
      default: null
    },
    descText: {
      type: String,
      default: null
    },
    displayStyle: {
      type: String,
      default: null
    },
    tagType: {
      type: Function,
      default: (row) => {
        return ''
      }
    },
    align: {
      type: String,
      default: 'center'
    }
  },
  data () {
    return {
      val: this.value,
      baseKey: 'api.optFields.' + this.name,
      filteredValue: [],
      disabledValue: [],
      dataName: this.data || this.name,
      propName: this.prop || this.data || this.name
    }
  },
  created () {
  },
  mounted () {
    if (!this.isForm) {
      this.$nextTick(() => {
        this.updateFilter(this.dataName)
      })
    }
  },
  computed: {
    rules () {
      return this.getRules(this.required)
    },
    opts () {
      let opts = []

      if (this.inputOpts.length > 0) {
        opts = this.inputOpts
      } else {
        opts = this.getMap(this.name || this.data, this.type)
        for (let i = 0; i < this.disabledValue.length; i++) {
          opts.find(x => x.value === this.disabledValue[i]).disabled = true
        }
      }

      for (let i = 0; i < this.hiddenValue.length; i++) {
        opts = opts.filter(item => item.value !== this.hiddenValue[i])
      }

      return opts
    },
    filters () {
      if (!this.hasFilter) {
        return null
      }
      let filters = []
      for (let i = 0; i < this.opts.length; i++) {
        filters[i] = {
          value: this.opts[i]['value'],
          text: this.opts[i]['label']
        }
      }
      return filters
    },
    label () {
      if (this.labelText !== null) {
        return this.labelText
      }
      if (!this.name) {
        return ''
      }
      let key = this.baseKey + '.label'
      let lkey = this.baseKey + '.listLabel'
      if (!this.isForm && this.$te(lkey)) {
        return this.$t(lkey)
      }
      return this.$t(key)
    },
    placeholder () {
      if (this.placeholderText !== null) {
        return this.placeholderText
      }
      if (this.disabled || !this.required) {
        return '-'
      }
      return this.getTransText(this.name, 'placeholder')
    },
    desc () {
      if (this.descText !== null) {
        return this.descText
      }
      return this.getTransText('optFields.' + this.name, 'desc')
    },
    swActiveText () {
      let key = this.baseKey + '.active'
      if (this.name && this.$te(key)) {
        return this.$t(key)
      }
      return ''
    },
    swInactiveText () {
      let key = this.baseKey + '.inactive'
      if (this.name && this.$te(key)) {
        return this.$t(key)
      }
      return ''
    }
  },
  methods: {
    doCopy,
    getMap,
    getTransText,
    updateFilter,
    updOptDisabled (val, disabled) {
      this.opts.find(x => x.value === parseInt(val)).disabled = disabled
      return this.opts
    },
    getOptLabel (val) {
      let v = this.opts.find(x => x.value === val)
      if (typeof v !== 'undefined') {
        return v.label
      }
      return val
    },
    getRetMsg (data) {
      const json = (function (raw) {
        try {
          return JSON.parse(raw)
        } catch (err) {
          return false
        }
      })(data.rtn_msg)
      if (!json) {
        return data.rtn_msg
      }
      return json.Status
    },
    onInput () {
      this.$emit('input', this.val)
    },
    getRules (v) {
      let def = []
      if (v) {
        def.push({
          required: v,
          message: this.getTransText(this.name, 'error'),
          trigger: 'blur'
        })
      }

      let rules = this.$attrs.rules
      if (rules) {
        return def.concat(rules)
      }
      return def
    }
  },
  watch: {
    value (newValue) {
      this.val = newValue
    },
    '$route.query' () {
      this.updateFilter(this.dataName)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .el-form {
    .el-radio {
      padding: 8px 10px 0 8px;
      height: 32px;
    }
  }
</style>
